module.exports = __webpack_public_path__ + "img/symbol_3.0824073f.png";